import { BrandLogo } from "../atoms/BrandLogo";
import { Navigation } from "../molecules/Navigation";
import { ThemeToggle } from "../atoms/ThemeToggle";
import { HeaderContainer, HeaderContent, NavWrapper, MobileRightSection } from "./Header.styles";

export const Header = () => {

  return (
    <HeaderContainer>
      <HeaderContent>
        <BrandLogo />
        
        {/* Desktop Navigation */}
        <NavWrapper>
          <Navigation />
        </NavWrapper>
        
        {/* Mobile Right Section: Toggle + Menu */}
        <MobileRightSection>
          <div className="mobile-nav">
            <Navigation />
          </div>
          <ThemeToggle />
        </MobileRightSection>
      </HeaderContent>
    </HeaderContainer>
  );
};